import * as Models from "../.";
export interface ICloneEpcAssumedValuesRequest {
  codeOfMarketToBeCloned: string;
  updatedMarketName: string;
  updatedDisplayStartDate: Date;
  updatedDisplayEndDate: Date;
  updatedEffectiveStartDate: Date;
  updatedEffectiveEndDate: Date;
}

export class CloneEpcAssumedValuesRequest
  implements ICloneEpcAssumedValuesRequest {
  codeOfMarketToBeCloned: string;
  updatedMarketName: string;
  updatedDisplayStartDate: Date;
  updatedDisplayEndDate: Date;
  updatedEffectiveStartDate: Date;
  updatedEffectiveEndDate: Date;

  constructor(
    baseAssumedValuesModel: Models.CostCalculation.MarketAssumedValuesModel.IMarketAssumedValuesModel
  ) {
    this.codeOfMarketToBeCloned = baseAssumedValuesModel.market.code;
    this.updatedMarketName = baseAssumedValuesModel.market.name + " (Clone)";
    this.updatedDisplayStartDate =
      baseAssumedValuesModel.market.displayStartDate;
    this.updatedDisplayEndDate = baseAssumedValuesModel.market.displayEndDate;
    this.updatedEffectiveStartDate =
      baseAssumedValuesModel.market.effectiveStartDate;
    this.updatedEffectiveEndDate =
      baseAssumedValuesModel.market.effectiveEndDate;
  }
}
